import React, { useEffect, useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';

import '../../scss/components/_user_management.scss';

const DisableUser = (props) => {

    return (
        <React.Fragment>
            <CssBaseline />
            <div className="disableuser-main">
                <Container className="disableuser-container" maxWidth="lg">
                    <div>
                        <div className="flex-cnt">
                            <img src={require('../../assets/icons/user-red.svg')} />
                            <div>
                                <label>Disable user - {props.username}?</label>
                                <p>Are you sure you want to disable this user? 
                                    Once disabled you will need to manually add groups back to the user to extended their permissions.
                                </p>
                            </div>
                        </div>
                        <div className="disable-btns-cnt">
                            <Button type="reset" variant="outlined" id="cancel_btn" className="cancel-btn" onClick={() => props.handleShowDisableUser(false)}>
                                Cancel</Button>&nbsp;&nbsp;
                            <Button 
                                type="submit" 
                                variant="outlined" 
                                id="disable_btn" 
                                className="red-btn"
                                onClick={props.handleDisableUser}
                            >
                                Disable
                            </Button>
                        </div>        
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default DisableUser;